<div class="container">
  <div class="card flat">
    <div class="card-wrapper">
      <div class="card-body">
        <div class="desktop">
          <h5 class="card-body-title">Hello {{ authorFirstName }}, Welcome to your Book Marketing Hub!</h5>
          @if (!isMember) {
            <p class="card-body-text">You are a Free Member. Get 10% off orders, early access to
              promo inventory, and other exclusive perks by <a (click)="showUpgradeModal()" class="card-body-text-link">upgrading</a>!</p>
            }
            @if (isMember) {
              <p class="card-body-text">You are a {{ memberRole }} Member. Smart Move!</p>
            }
          </div>
          <div class="mobile card-body-title">
            Hello {{ authorFirstName }}!
          </div>
          <a class="button-action button-primary" (click)="runPromotion()">Run a Promotion</a>
        </div>
      </div>
    </div>
  </div>
